import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import NotesCard from "./Patient/components/NotesCard";

interface Props {
  notes: string; // can be "";
}

const AvailableVisitGeneralNotes = (props: Props) => {
  return (
    <NotesCard
      title={translate(STRINGS.GENERAL_NOTES)}
      notes={props.notes === "" ? null : props.notes}
    />
  );
};

export default AvailableVisitGeneralNotes;
